const router = [
  {
    path: "*",
    redirect: "/connect"
  },
  {
    path: "/connect",
    name: "Connect",
    meta: { layout: () => import("@/layouts/Mini"), title: "Engagement - Connexion" },
    component: () => import("@/connect/pages/main"),
    props: { B_Disconnect: false }
  },
  {
    path: "/disconnect",
    name: "Disconnect",
    meta: { layout: () => import("@/layouts/Mini"), title: "Engagement - Connexion" },
    component: () => import("@/connect/pages/main"),
    props: { B_Disconnect: true }
  },
  {
    path: "/home",
    name: "Accueil",
    meta: { layout: () => import("@/layouts/BaseHome") },
    component: () => import("@/home/pages/main")
  },
  {
    path: "/budget",
    name: "Budget",
    meta: { layout: () => import("@/layouts/Base"), title: "Engagement - Budgets" },
    component: () => import("@/budget/pages/main")
  },
  {
    path: "/autorisation",
    name: "Autorisation",
    meta: { layout: () => import("@/layouts/Base"), title: "Engagement - Autorisations" },
    component: () => import("@/autorisation/pages/main")
  },
  {
    path: "/engagement",
    name: "Engagement",
    meta: { layout: () => import("@/layouts/Base"), title: "Engagement - Liste" },
    component: () => import("@/engagement/pages/main")
  },
  {
    path: "/engagement/add",
    name: "Engagement-Add",
    meta: { layout: () => import("@/layouts/BaseHome"), title: "Engagement - Ajout" },
    component: () => import("@/engagement/pages/edit"),
    props: { T_EditMode: "Add" }
  },
  {
    path: "/engagement/edit/:id",
    name: "Engagement-Edit",
    meta: { layout: () => import("@/layouts/BaseHome"), title: "Engagement - Edition" },
    component: () => import("@/engagement/pages/edit"),
    props: { T_EditMode: "Mod" }
  },
  {
    path: "/approbation",
    name: "Approbation",
    meta: { layout: () => import("@/layouts/Base"), title: "Engagement - Approbation" },
    component: () => import("@/approbation/pages/main")
  },
  {
    path: "/configuration",
    name: "Configuration",
    meta: { layout: () => import("@/layouts/Base"), title: "Engagement - Configuration" },
    component: () => import("@/configuration/pages/main")
  }
];

export default router;
